import ActionKeys from '../actions/ActionKeys';

const initialState = {
    detail: null,
};



export const cancelTicketReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionKeys.CANCELLATION_TICKET.GET_DETAIL:
            return {
                ...state,
                detail: action.data,
            };
        default:
            return state;
    }
};
